<template>
  <div>
    <router-view v-show="$route.matched.length==3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length==2">
      <div class="main-page-content">

        <!-- 操作按钮区域 -->
        <div class="action-card">
          <div class="action-buttons">
            <el-button 
              type="primary" 
              size="medium" 
              class="action-btn primary-btn"
              @click="addButton()">
              <i class="el-icon-plus"></i>
              添加问答
            </el-button>
          </div>
        </div>

        <!-- 搜索区域 -->
        <div class="search-card">
          <div class="search-header">
            <h3 class="search-title">
              <i class="el-icon-search"></i>
              搜索筛选
            </h3>
          </div>
          <div class="search-content">
            <el-form size="medium" :inline="true" :model="searchCondition" class="search-form">
              <div class="form-row">
                <div class="form-item">
                  <label class="form-label">显示语言</label>
                  <div class="input-wrapper">
                    <el-select v-model="searchCondition.lang" placeholder="原文" clearable @change="searchButton" style="width:140px">
                      <el-option v-for="l in contentLocales" :key="l" :label="localeLabel(l)" :value="l"></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="form-item">
                  <label class="form-label">问题关键词</label>
                  <div class="input-wrapper">
                    <el-input 
                      v-model="searchCondition.question" 
                      placeholder="输入问题关键词"
                      prefix-icon="el-icon-edit-outline"
                      clearable>
                    </el-input>
                  </div>
                </div>
                <div class="form-item">
                  <label class="form-label">状态筛选</label>
                  <div class="input-wrapper">
                    <el-select 
                      v-model="searchCondition.fqa_status" 
                      placeholder="请选择状态"
                      clearable>
                      <el-option
                        v-for="item in fqa_status"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="form-item" style="margin-left: 60px;">
                  <label class="form-label">首页推荐</label>
                  <div class="input-wrapper">
                    <el-select 
                      v-model="searchCondition.fqa_recommend" 
                      placeholder="请选择推荐状态"
                      clearable>
                      <el-option label="是" value="1"></el-option>
                      <el-option label="否" value="0"></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="form-item" style="margin-left: 60px;">
                  <label class="form-label">问答分类</label>
                  <div class="input-wrapper">
                    <el-select 
                      v-model="searchCondition.category_id" 
                      placeholder="请选择问答分类"
                      clearable>
                      <el-option
                        v-for="item in category_list"
                        :key="item.id"
                        :label="item.category_name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="form-item" style="margin-left: 20px;">
                  <div class="button-group">
                    <el-button 
                      type="primary" 
                      size="medium"
                      class="search-btn"
                      @click="searchButton">
                      <i class="el-icon-search"></i>
                      查询
                    </el-button>
                  </div>
                </div>
              </div>
            </el-form>
          </div>
        </div>

        <!-- 表格区域 -->
        <div class="table-card">
          <div class="table-header">
            <h3 class="table-title">
              <i class="el-icon-s-grid"></i>
              问答列表
            </h3>
            <div class="table-tools">
              <span class="data-count">共 {{articleList.length}} 条数据</span>
            </div>
          </div>
          <div class="table-content">
            <div class="modern-table">
              <ApeTable ref="apeTable" :data="articleList" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row>
                <el-table-column
                  slot="first-column"
                  width="80"
                  align="center"
                  label="排序">
                  <template slot-scope="scope">
                    <el-tooltip effect="dark" content="拖动排序" placement="top-start">
                      <span class="drag-handle" :data-id="scope.row.id" :data-parent_id="scope.row.pid" :data-depth="scope.row.depth">
                        <i class="el-icon-rank"></i>
                      </span>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column
                  width="64"
                  label="序号"
                  align="center">
                  <template slot-scope="scope">
                    <div class="serial-number">{{offset+scope.$index+1}}</div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="问题信息"
                  min-width="300">
                  <template slot-scope="scope">
                    <div class="question-cell">
                      <div class="question-title">
                        <i class="el-icon-help"></i>
                        {{scope.row.question}}
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="回答内容"
                  min-width="200">
                  <template slot-scope="scope">
                    <div class="answer-cell">
                      <div class="answer-content">{{ qaAnswerPreview(scope.row.answer) }}</div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="首页推荐"
                  width="100"
                  align="center">
                  <template slot-scope="scope">
                    <div class="recommend-cell">
                      <el-switch
                        v-model="scope.row.fqa_recommend"
                        active-color="#67C23A"
                        inactive-color="#F56C6C"
                        active-value="1"
                        inactive-value="0"
                        class="status-switch"
                        @change="changeStatus(scope.row)">
                      </el-switch>
                      <div class="switch-label">
                        <i class="el-icon-star-on" v-if="scope.row.fqa_recommend == 1"></i>
                        {{ scope.row.fqa_recommend == 1 ? '推荐' : '普通' }}
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="状态"
                  width="100"
                  align="center">
                  <template slot-scope="scope">
                    <div class="status-cell">
                      <el-switch
                        v-model="scope.row.fqa_status"
                        active-color="#67C23A"
                        inactive-color="#F56C6C"
                        active-value="1"
                        inactive-value="0"
                        class="status-switch"
                        @change="changeStatus(scope.row)">
                      </el-switch>
                      <div class="switch-label">
                        <i class="el-icon-success" v-if="scope.row.fqa_status == 1"></i>
                        <i class="el-icon-error" v-else></i>
                        {{ scope.row.fqa_status == 1 ? '已发布' : '草稿' }}
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  width="160"
                  label="操作"
                  align="center">
                  <template slot-scope="scope">
                    <div class="action-cell">
                      <el-tooltip effect="dark" content="编辑" placement="top-start">
                        <el-button 
                          size="mini" 
                          type="primary"
                          icon="el-icon-edit" 
                          class="table-action-btn edit-btn"
                          @click="editButton(scope.row.id)">
                        </el-button>
                      </el-tooltip>
                      <el-tooltip effect="dark" content="子问题" placement="top-start" v-if="parent_id==0">
                        <el-button 
                          size="mini" 
                          type="warning"
                          icon="el-icon-arrow-down" 
                          class="table-action-btn child-btn"
                          @click="getChildButton(scope.row.id)">
                        </el-button>
                      </el-tooltip>
                      <el-tooltip effect="dark" content="删除" placement="top-start">
                        <el-popconfirm
                          title="确定删除这个问答及其子问题吗？"
                          confirm-button-text="删除"
                          cancel-button-text="取消"
                          @confirm="deleteButton(scope.row.id)">
                          <el-button
                            slot="reference"
                            size="mini"
                            type="danger"
                            icon="el-icon-delete"
                            class="table-action-btn delete-btn">
                          </el-button>
                        </el-popconfirm>
                      </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </ApeTable>
            </div>
          </div>
        </div>
      </div>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeDrawer from '@/components/ApeDrawer'
import ApeUploader from '@/components/ApeUploader'
import ModalDialog from '@/components/ModalDialog'
import Sortable from 'sortablejs'
import { mapGetters } from 'vuex'

export default {
  components: {
    PageHeaderLayout,
    ApeDrawer,
    ApeTable,
    ApeUploader,
    ModalDialog
  },
  data() {
    return {
      contentLocales: ['en', 'zh', 'tw', 'ar', 'es', 'ru', 'nl', 'pl', 'it', 'fr', 'de', 'pt', 'ja', 'ko', 'hi', 'tr', 'id', 'ur', 'vi', 'th'],
      searchCondition:{
        current_page: 1,
        page_size: 20,
        lang: 'en',
        query:"",
        order_by:"fqa_rank asc",
        params:[]
      },
      parent_id:0,
      loadingStaus: true,
      fqa_status:[
        {label:'启用',value:1},
        {label:'禁用',value:0},
      ],
      category_list:[],
      // 表格列表数据
      articleList:[],
      // 分页信息
      pagingData:{
        page_size: 20,
        current_page: 1,
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      // 分页的offset,序号列使用
      offset:0,
      // 已上传文件列表
      uploadFileList:[],
      // 表单验证
      rules: {
        title: [
          {required: true, message: '输入标题', trigger: 'blur' },
        ],
        type: [
          {required: true, message: '选择类型', trigger: 'blur' },
        ],
        is_new_win: [
          {required: true, message: '选择打开发方式', trigger: 'blur' },
        ],
        is_show: [
          {required: true, message: '选择状态', trigger: 'blur' },
        ],
        image: [
          {required: true, message: '上传图片', trigger: 'blur', validator:this.apeUploaderVerify},
        ],
      },
      // 抽屉数据，附件列表
      drawerData: {
        visible: false,
        loading: true,
        loading_text: '玩命加载中……',
        // direction: 'right',
        title: '',
        width_height: '640px',
        show_footer:false,
        // mask: false,
        // close_name: '关 闭',
        // confirm_name: '打 印',
      },
      // 添加附件
      dialogData:{
        visible: false,
        title: '',
        width: '24%',
        loading: true,
        modal: false
      },
      // 附件表单内容
      formData:{},
      // 附件添加表单验证
      dialogRules: {
        title: [{required: true, message: '输入标题', trigger: 'blur' }],
      },
      currentArticleId:0,
    }
  },
  computed: {
    ...mapGetters(['userPermissions','buttonType'])
  },
  watch: {
    "$route.matched" : function(n) {
    if (n.length === 2) {
        this.list()
      }
    }
  },
  methods: {
    qaAnswerPreview (html) {
      if (html == null || html === '') return ''
      const plain = String(html).replace(/<[^>]+>/g, '')
      return plain.length > 200 ? plain.substring(0, 200) + '...' : plain
    },
    // 搜索
    getallUrl(url){
      if(url==null || url=='' || url==undefined){
        return ''
      }
      if(url.startsWith("http")){
        return url
      }else if(url.startsWith("/")){
        return window.location.origin + url
      }else{
        return window.location.origin + "/" + url
      }
    },
    searchButton() {
      this.$refs['apeTable'].currentPage=1
      this.list()
    },
    // 切换页码操作
    async switchPaging() {
      this.list()
    },
    // 响应添加按钮
    async addButton() {
      if(this.$route.query.pid!=undefined&&this.$route.query.pid!=''){
        window.open(this.$route.path+'/create?pid='+this.$route.query.pid, '_blank');
      }else{
        window.open(this.$route.path+'/create', '_blank');
      }
    },
    async getChildButton(id){
      window.open('/cms/question?pid='+id, '_blank');
    },
    // 响应编辑按钮
    async editButton(id) {
      if(this.$route.query.pid!=undefined&&this.$route.query.pid!=''){
        window.open(this.$route.path+'/'+ id +'/edit?pid='+this.$route.query.pid, '_blank');
      }else{
        window.open(this.$route.path+'/'+ id +'/edit', '_blank');
      }
    },
    // 相应删除按钮（级联删除子问题）
    async deleteButton(id) {
      let res = await this.$api.post('/service/fqa/delete',{id:id})
      if (this.$apiSuccess(res)) {
        this.$message.success('删除成功!')
        this.list()
      } else {
        this.$message.error(res.message)
      }
      
    },
    async changeStatus(row){
      let res = await this.$api.post('/service/ola_app_fqa/update',row)
      if (this.$apiSuccess(res)){
        this.$message.success('修改状态成功!')
      }else{
        this.$message.error(res.message)
      }
    },
    // 处理抽屉关闭
    drawerClose() {
      this.drawerData.visible = false
      this.drawerData.loading = true
    },
    // 初始化新闻列表
    async list() {
      this.loadingStaus=true
      this.handleSearchCondition()
      let res = await this.$api.post('/service/ola_app_fqa/list',this.searchCondition)
      if (this.$apiSuccess(res)){
        this.articleList = res.data.list
        this.pagingData.total = res.data.page.total
        this.loadingStaus=false
      }else{
        this.$message.error(res.message)
      }
    },
    // 处理搜索条件
    handleSearchCondition() {
      let pagingInfo = this.$refs['apeTable'].getPagingInfo()
      this.searchCondition.page_size = pagingInfo.page_size
      this.searchCondition.current_page = pagingInfo.current_page
      this.searchCondition.params = []
      this.searchCondition.query = ''
      if(this.$route.query.pid!=undefined&&this.$route.query.pid!=''){
        this.setSearchCondition(' pid = ? ',this.$route.query.pid)
      } else {
        // 顶级问答（迁移后 pid 统一为 0）
        this.setSearchCondition(' pid = ? ','0')
      }
      if (this.searchCondition.question) {
        this.setSearchCondition(' INSTR(question,?) ',this.searchCondition.question)
      }
      if (this.searchCondition.fqa_status) {
        this.setSearchCondition(' fqa_status = ? ',this.searchCondition.fqa_status)
      }
      if (this.searchCondition.fqa_recommend) {
        this.setSearchCondition(' fqa_recommend = ? ',this.searchCondition.fqa_recommend)
      }
      if (this.searchCondition.category_id) {
        this.setSearchCondition(' category_id = ? ',this.searchCondition.category_id)
      }
    },
    setSearchCondition(condition,v) {
      if (this.searchCondition.query == '' ){
          this.searchCondition.query = condition
        }else{
          this.searchCondition.query = this.searchCondition.query + ' and ' + condition
        }
      this.searchCondition.params.push(v)
    },
    // form数据提交，请求接口,新闻附件
    async formSubmit() {
      this.dialogData.loading_text = '玩命提交中……'
      this.dialogData.loading = true
      let url = '/service/ola_app_fqa/create'
      if (this.formData.id != '') {
        url = '/service/ola_app_fqa/update'
      }
      let res = await this.$api.post(url,this.formData)
      if (this.$apiSuccess(res)) {
        this.$message.success('保存成功!')
        this.list()
      }else{
        this.$message.error(res.message)
      }
    },
    // 处理模态框，确定事件
    handleConfirm() {
      // 调用组件的数据验证方法
      this.$refs['articleAttacmentForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    async getCategoryList(){
      if (this.$route.query.pid!=undefined&&this.$route.query.pid!=''){
          this.parent_id = this.$route.query.pid
          return
      }
      let res = await this.$api.post('/service/ola_app_fqa_category/list',{
        current_page:1,
        page_size:1000,
        order_by:'category_rank asc'
      })
      if (this.$apiSuccess(res)){
        this.category_list = res.data.list || []
      }
    },
    // 处理模态框，关闭事件
    dialogClose() {
      this.dialogData.visible = false
      this.dialogData.loading = true
      this.formData = {}
    },
    // 拖拽排序数据提交，请求接口
    async dragSortSubmit(orderIds) {
      let res = await this.$api.post('/service/ola_app_fqa/order',{orderIds:orderIds,sort_field:'fqa_rank'})
      if (this.$apiSuccess(res)){
        this.$message.success('排序成功!')
        this.list()
      }else{
        this.$message.error('排序失败!')
      }
    },
    // 表格拖拽排序，同层级移动有效果
    dragSort() {
      const el = document.querySelectorAll('.el-table__body-wrapper > table > tbody')[0]
      this.sortable = Sortable.create(el,{
        handle: ".drag-handle", 
        setData: function(dataTransfer) {
          dataTransfer.setData('Text', '')
        },
        onEnd: () => {
          let Ids = []
          let tmp = el.querySelectorAll('.drag-handle')
          for (let i=0,len=tmp.length; i < len; i++) {
            Ids.push(tmp[i].dataset.id)
          }
          this.dragSortSubmit(Ids)
        },
      })
    },
    localeLabel(l) {
      return ({
        en: 'English（英语）', zh: '中文（简体）', tw: '中文（繁體）', ar: 'العربية（阿拉伯语）',
        es: 'Español（西班牙语）', ru: 'Русский（俄语）', nl: 'Nederlands（荷兰语）', pl: 'Polski（波兰语）',
        it: 'Italiano（意大利语）', fr: 'Français（法语）', de: 'Deutsch（德语）', pt: 'Português（葡萄牙语）',
        ja: '日本語（日语）', ko: '한국어（韩语）', hi: 'हिन्दी（印地语）', tr: 'Türkçe（土耳其语）',
        id: 'Bahasa Indonesia（印尼语）', ur: 'اردو（乌尔都语）', vi: 'Tiếng Việt（越南语）', th: 'ไทย（泰语）'
      })[l] || l
    },
    async loadI18nMeta() {
      try {
        const res = await this.$api.post('/service/i18n/meta', {})
        if (this.$apiSuccess(res)) {
          this.contentLocales = res.data.content_locales || this.contentLocales
          this.searchCondition.lang = res.data.source_locale || 'en'
        }
      } catch (e) {
        // meta optional
      }
    }
  },
  async mounted() {
    await this.loadI18nMeta()
    this.list()
    this.getCategoryList()
    this.$nextTick(() => {
      this.dragSort()
    })
  },
}
</script>

<style lang="stylus" scoped>
.main-page-content
  padding 0
  
// 页面标题区域
.page-title-section
  background linear-gradient(135deg, #667eea 0%, #764ba2 100%)
  padding 32px
  margin-bottom 24px
  border-radius 12px
  color #fff
  
  .title-content
    .page-title
      font-size 28px
      font-weight 600
      margin 0 0 8px 0
      display flex
      align-items center
      gap 12px
      
      i
        font-size 32px
        opacity 0.9
        
    .page-subtitle
      font-size 16px
      opacity 0.9
      margin 0

// 操作卡片
.action-card
  background #fff
  border-radius 12px
  padding 24px
  margin-bottom 24px
  box-shadow 0 2px 12px rgba(0,0,0,0.1)
  border 1px solid #f0f0f0
  
  .action-header
    margin-bottom 16px
    
    .action-title
      font-size 16px
      font-weight 600
      color #303133
      margin 0
      display flex
      align-items center
      gap 8px
      
      i
        color #409EFF
        
  .action-buttons
    display flex
    gap 12px
    
    .action-btn
      height 40px
      padding 0 20px
      border-radius 8px
      font-weight 500
      transition all 0.3s ease
      
      &.primary-btn
        background linear-gradient(135deg, #409EFF 0%, #66B3FF 100%)
        border none
        box-shadow 0 4px 12px rgba(64,158,255,0.3)
        
        &:hover
          transform translateY(-2px)
          box-shadow 0 6px 16px rgba(64,158,255,0.4)

// 搜索卡片
.search-card
  background #fff
  border-radius 12px
  padding 24px
  margin-bottom 24px
  box-shadow 0 2px 12px rgba(0,0,0,0.1)
  border 1px solid #f0f0f0
  
  .search-header
    margin-bottom 20px
    border-bottom 1px solid #f0f0f0
    padding-bottom 12px
    
    .search-title
      font-size 16px
      font-weight 600
      color #303133
      margin 0
      display flex
      align-items center
      gap 8px
      
      i
        color #409EFF
        
  .search-content
    .search-form
      .form-row
        display flex
        flex-wrap wrap
        gap 16px
        align-items flex-end
        
        .form-item
          flex none
          margin-bottom 16px
          
          .form-label
            display block
            font-size 14px
            color #606266
            margin-bottom 8px
            font-weight 500
            
          .input-wrapper
            /deep/ .el-input
              width 180px
              
              .el-input__inner
                border-radius 8px
                border 2px solid #f0f0f0
                transition all 0.3s ease
                
                &:focus
                  border-color #409EFF
                  box-shadow 0 0 0 2px rgba(64,158,255,0.1)
                  
            /deep/ .el-select
              width 150px
              
              .el-input__inner
                border-radius 8px
                border 2px solid #f0f0f0
                transition all 0.3s ease
                
                &:focus
                  border-color #409EFF
                  box-shadow 0 0 0 2px rgba(64,158,255,0.1)
                  
          .button-group
            display flex
            gap 8px
            
            .search-btn
              background linear-gradient(135deg, #409EFF 0%, #66B3FF 100%)
              border none
              border-radius 8px
              padding 10px 20px
              font-weight 500
              box-shadow 0 2px 8px rgba(64,158,255,0.3)
              
              &:hover
                transform translateY(-1px)
                box-shadow 0 4px 12px rgba(64,158,255,0.4)

// 表格卡片
.table-card
  background #fff
  border-radius 12px
  padding 24px
  box-shadow 0 2px 12px rgba(0,0,0,0.1)
  border 1px solid #f0f0f0
  
  .table-header
    display flex
    justify-content space-between
    align-items center
    margin-bottom 20px
    padding-bottom 12px
    border-bottom 1px solid #f0f0f0
    
    .table-title
      font-size 16px
      font-weight 600
      color #303133
      margin 0
      display flex
      align-items center
      gap 8px
      
      i
        color #409EFF
        
    .table-tools
      .data-count
        color #909399
        font-size 14px

// 表格样式
.modern-table
  /deep/ .el-table
    border-radius 8px
    overflow hidden
    
    .el-table__header
      background #f8f9fa
      
      th
        background #f8f9fa !important
        color #303133
        font-weight 600
        border-bottom 2px solid #e4e7ed
        
    .el-table__body
      tr
        transition all 0.3s ease
        
        &:hover
          background-color #f5f7fa
          
        td
          border-bottom 1px solid #f0f0f0

// 拖拽排序手柄
.drag-handle
  font-size 20px
  color #909399
  cursor move
  padding 4px
  border-radius 4px
  transition all 0.3s ease
  
  &:hover
    color #409EFF
    background #f0f9ff

// 表格单元格样式
.serial-number
  font-weight 600
  color #606266
  background #f8f9fa
  padding 4px 8px
  border-radius 4px
  display inline-block
  min-width 28px
  text-align center

.cover-cell
  .cover-image
    width 64px
    height 64px
    border-radius 8px
    object-fit cover
    border 2px solid #f0f0f0
    transition all 0.3s ease
    
    &:hover
      border-color #409EFF
      transform scale(1.05)

.question-cell
  .question-title
    font-size 16px
    font-weight 600
    color #303133
    display flex
    align-items center
    gap 8px
    line-height 1.4
    
    i
      color #409EFF
      flex-shrink 0

.answer-cell
  .answer-content
    color #606266
    font-size 14px
    line-height 1.5
    max-height 60px
    overflow hidden

.recommend-cell, .status-cell
  display flex
  flex-direction column
  align-items center
  gap 8px
  
  .status-switch
    /deep/ .el-switch__core
      border-radius 10px
      
  .switch-label
    font-size 12px
    color #909399
    display flex
    align-items center
    gap 4px
    
    i
      font-size 14px

.action-cell
  display flex
  gap 4px
  justify-content center
  
  .table-action-btn
    width 28px
    height 28px
    border-radius 6px
    padding 0
    display inline-flex
    align-items center
    justify-content center
    transition all 0.3s ease
    
    &.edit-btn
      background #409EFF
      border-color #409EFF
      
      &:hover
        background #66B3FF
        transform translateY(-2px)
        box-shadow 0 4px 12px rgba(64,158,255,0.3)
        
    &.child-btn
      background #E6A23C
      border-color #E6A23C
      
      &:hover
        background #F7BA2A
        transform translateY(-2px)
        box-shadow 0 4px 12px rgba(230,162,60,0.3)
        
    &.delete-btn
      background #F56C6C
      border-color #F56C6C
      
      &:hover
        background #F78989
        transform translateY(-2px)
        box-shadow 0 4px 12px rgba(245,108,108,0.3)

// 响应式设计
@media (max-width: 1200px)
  .search-content
    .search-form
      .form-row
        .form-item
          .input-wrapper
            /deep/ .el-input
              width 160px
              
            /deep/ .el-select
              width 130px

@media (max-width: 768px)
  .page-title-section
    padding 20px
    
    .title-content
      .page-title
        font-size 24px
        
  .action-card, .search-card, .table-card
    padding 16px
    
  .action-buttons
    flex-direction column
    
    .action-btn
      width 100%
      margin-bottom 8px
      
  .search-content
    .search-form
      .form-row
        flex-direction column
        align-items stretch
        
        .form-item
          width 100%
          
          .input-wrapper
            /deep/ .el-input, /deep/ .el-select
              width 100%
              
  .action-cell
    flex-direction column
    gap 4px
    
    .table-action-btn
      width 26px
      height 26px
</style>
